/**
 * Singleton API client for Promotions module
 *
 * Centralizes all API calls with proper typing.
 * Uses Infrastructure's request helper.
 */

import { request } from '../../../Infrastructure'
import { getCategoryAndProducts, getCmsBlock } from '../queries'

import type { Category, CmsBlock } from '../types'

// Exported response data types for hooks
export interface CategoriesData {
  categoryList: Category[]
}

export interface CmsBlocksData {
  block1?: {
    items: CmsBlock[]
  }
  block2?: {
    items: CmsBlock[]
  }
}

/**
 * Promotions API client
 *
 * Note: request<T>() returns Promise<{ data: T }>, so we unwrap to return T directly
 */
export const promotionsApi = {
  /**
   * Fetch categories with products
   */
  getCategoriesWithProducts: async (
    categoryId: string,
    pageSize: string,
    currentPage: string
  ): Promise<CategoriesData> => {
    const response = await request<CategoriesData>(getCategoryAndProducts, {
      categoryId,
      pageSize,
      currentPage,
    })
    return response.data
  },

  /**
   * Fetch CMS blocks
   */
  getCmsBlocks: async (identifier1: string, identifier2: string): Promise<CmsBlocksData> => {
    const response = await request<CmsBlocksData>(getCmsBlock, { identifier1, identifier2 })
    return response.data
  },
}
